/**
 * The assignment types an assignment block can carry. Kept in sync with the
 * options returned by `getAssignmentTypes` in `@/defaults/assignmentTypes`.
 *
 * This lives in `shared` rather than next to those options because the server
 * needs the type too, and the options pull in icons and i18n that only resolve
 * in the browser build.
 */
export const assignmentTypes = [
  'text',
  'flash',
  'editorial-info',
  'graphic',
  'picture',
  'video',
  'picture/video',
  'timeless'
] as const

export type AssignmentType = (typeof assignmentTypes)[number]
